import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "./fixLeafletIcon"; // make sure this is imported so marker shows

export default function MapWidget() {
  const position = [37.7749, -122.4194]; // San Francisco Bay Area

  return (
    <MapContainer
      center={position}
      zoom={12}
      style={{ height: "100%", width: "100%", zIndex: "9", borderRadius: "5%"}}
    >
      {/* OpenStreetMap tiles */}
      {/* <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
        subdomains={['a','b','c','d']}
      /> */}
       <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        subdomains={["a", "b", "c", "d"]}
      />
      {/* Marker */}
      <Marker position={position}>
        <Popup>📍 San Francisco Bay Area</Popup>
      </Marker>
    </MapContainer>
  );
}

